/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryClient, useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import { PaginatedResult } from "services/@types";
import apiInputService from "services/apiInputService";
import { ActivityItemWorker } from "../work-items/@types";

const fetch = async (role: string, params: any): Promise<PaginatedResult<ActivityItemWorker>> => {
    const stats = await apiInputService.get("/frontend/dashboard/activityItem/role", {
        params: {
            role,
            ...params
        }
    })
    const { data } = stats;

    return data as PaginatedResult<ActivityItemWorker>;
}


export const useDashboardAtvsRequiringActionByRole = (
    role: string,
    params: any,
    options?: any
) => {

    const { subscription } = useSubscription();

    return useQuery(
        ["dashboard", "atvs", role, subscription?.subscriptionId, params], 
        () => fetch(role, params), {
        ...options,
        enabled: !!subscription?.subscriptionId && !!role,
        keepPreviousData: true
    });
}


export const prefetchData = (queryClient: QueryClient, role: string, params: any, subscription: string) => {
    queryClient.prefetchQuery(
        ["dashboard", "atvs", role, subscription, params], 
        () => fetch(role, params),
        {
            staleTime: 1000 * 60 * 5,
        }
    )
}